import { initializeApp } from 'firebase/app';
import 'firebase/auth';
import { getAuth } from 'firebase/auth';
import { getMessaging } from 'firebase/messaging';
import { getAnalytics } from 'firebase/analytics';

import {
  initializeFirestore,
  persistentMultipleTabManager,
  tabManager,
  persistentLocalCache,
} from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyCt1krur7RzJ_5bMuqv0AUFLwGGNM_dOI4',
  authDomain: 'baws-389800.firebaseapp.com',
  projectId: 'baws-389800',
  storageBucket: 'baws-389800.appspot.com',
  messagingSenderId: '644488033982',
  appId: '1:644488033982:web:23a3842a910f83d8d950ef',
  measurementId: 'G-F638WGHNCT',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics();
export const auth = getAuth(app);
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache(
    /*settings*/ { tabManager: persistentMultipleTabManager() }
  ),
});

export const isSupported = () =>
  'Notification' in window &&
  'serviceWorker' in navigator &&
  'PushManager' in window;

// notification configs
export let messaging = null;
try {
  messaging = getMessaging();
} catch (error) {
  console.log('Firebase Messaging not supported', error);
}
